export const checkoutTR = {
  "less255": "Maksimum 255 karakter",
  "less50": "Maksimum 50 karakter",
  "less20": "Maksimum 20 karakter",
  "less10": "Maksimum 10 karakter",
  "required": "Zorunlu alan",
  "invalidEmail": "Geçersiz e-posta",
  "invalidPhone": "Geçersiz numara",
  "textareaMax": "Maksimum 1000 karakter",
  "invalidPayment": "Geçersiz ödeme yöntemi",
  "terms": "Şartlar ve koşulları kabul etmelisiniz",
  "createAccount": "Hesap Oluştur",
  "differentDeliveryAddress": "Farklı bir adrese teslimat",
  "orderComments": "Sipariş Notları",
  "payment": "ÖDEME",
  "cash": "Kapıda ödeme",
  "cashInShop": "Mağazada ödeme",
  "cashText": "Ürünler teslim edildiğinde nakit ödeme yapın",
  "clickAway": "Mağazadan Al",
  "clickAwayText": "Ürünleri mağazadan alın",
  "paypalRadio": "Kredi kartı veya PayPal",
  "vivaRadio": "Kredi kartı veya Viva",
  "creditCard": "Kredi kartı",
  "paypalError": "Lütfen formu doğru şekilde doldurunuz!",
  "personalDataInfo": "Kişisel verileriniz bu sitenin ihtiyaçları ve hesabınızın yönetimi için kullanılacaktır.",
  "readThe": "Okuyun",
  "iHaveRead": "Okudum ve kabul ediyorum",
  "ofThisSite": "bu sitenin",
  "yourOrder": "Siparişiniz",
  "sendOrder": "Siparişi Gönder",
  "alreadyCustomer": "Zaten bir müşteriyim",
  "orderCompleteTitle": "SİPARİŞ TAMAMLANDI!",
  "orderCompleteLine1": "Siparişiniz başarıyla alındı.",
  "orderCompleteLine2": "Siparişiniz için teşekkür ederiz.",
  "isCompany": "Fatura Kesilsin",
  "companyAfm": "Vergi Numarası",
  "companyDoy": "Vergi Dairesi",
  "companyName": "Şirket Adı",
  "companyProfession": "Meslek",
  "bankTransfer": "Banka Havalesi",
  "bankTransferText": "Banka hesaplarımızdan birine transfer yapın.",
  "bankLargeText": "Ödemenizi doğrudan banka hesabımıza yapın. Lütfen banka havalenizde sipariş numaranızı belirtin. Ödemeniz onaylandıktan sonra siparişiniz kargolanacaktır.",
  "bank": "Banka",
  "nbgRadio": "NBG Bankası ile kredi kartı",
  "without": "OLMAKSIZIN",
  "checkoutData": "Ödeme/Teslimat detayları",
  "product": "ÜRÜN",
  "subTotal": "ARA TOPLAM",
  "total": "TOPLAM",
  "doYouHave": "Zaten bir hesabınız var mı? ",
  "here": "Buraya",
  "toConnect": " tıklayarak giriş yapın.",
  "legalName": "Yasal Ad",
  "legalDescription": "Şirket türü",
  "postalAddress": "Ana cadde",
  "postalAddressNo": "Numara",
  "postalAreaDescription": "İlçe",
  "postalZipCode": "Posta kodu",
  "firmActDescription": "Ana faaliyet",
  "companyPhone": "Telefon",
  "companyEmail": "E-posta",
  "doyDescription": "Vergi dairesi adı",
  "returnToShop": "MAĞAZAYA DÖN",
  "alergies": "Herhangi bir gıdaya alerjiniz veya intoleransınız var mı? Beslenme özel gereksinimleriniz? Siparişinizi vermeden önce mağaza ile iletişime geçin.",
  "proceedToPayment": "ÖDEMEYE GEÇ",
  "allowRecurring": "Tekrarlayan ödeme",
  "subscriptionInterval": "Ödemeler arasındaki ay cinsinden süre",
  "delivery": "Teslimat",
  "orderKind": "Teslimat şekli",
  "scheduleForLater": "Sonrası için planla",
  "scheduledDeliveryTime": "Teslimat zamanı planla",
  "scheduledPickupTime": "Teslim alma zamanı planla",
  "fillAllFields": "Lütfen tüm zorunlu alanları doldurun.",
  "invalidTotal": "Geçersiz sipariş toplamı. Lütfen sepetinizi kontrol edin.",
  "paymentError": "Ödeme başarısız oldu. Lütfen tekrar deneyin.",
  invalidVat: "Invalid VAT number",
  pickupNoAddress: "Mağazadan teslim alma — teslimat adresi gerekmez.",
}